import React, { FC } from 'react'

import type { SlotProps } from 'input-otp'

export interface OtpInputSlotsProps {
  slots: SlotProps[]
}

const OtpSlotCell: FC<{ slot: SlotProps }> = ({ slot }) => (
  <div className={`checkout-otp-input__slot${slot.isActive ? ' checkout-otp-input__slot--active' : ''}`}>
    {slot.char || slot.placeholderChar || ''}
    {slot.hasFakeCaret ? <span aria-hidden className="checkout-otp-input__caret" /> : null}
  </div>
)

const OtpInputSlots: FC<OtpInputSlotsProps> = ({ slots }) => (
  <>
    <div className="checkout-otp-input__group">
      {slots.slice(0, 3).map((slot, idx) => (
        <OtpSlotCell key={`otp-left-${idx}`} slot={slot} />
      ))}
    </div>

    <span aria-hidden className="checkout-otp-input__divider">
      —
    </span>

    <div className="checkout-otp-input__group">
      {slots.slice(3).map((slot, idx) => (
        <OtpSlotCell key={`otp-right-${idx}`} slot={slot} />
      ))}
    </div>
  </>
)

export default OtpInputSlots
